// FILE: ../Utils/CategoriesFiles.js
export const CATEGORIES = [
    { id: 70175, name: "Pâtisserie" },
    { id: 70176, name: "Tahina" },
    { id: 70177, name: "Jelly" },
    { id: 228830, name: "Baklava Vrac" },
    { id: 70178, name: "Biscuit" },
    { id: 70179, name: "DAIRY" },
    { id: 70180, name: "Spices & Herbs (500g)" },
    { id: 70181, name: "Outils" },
    { id: 70182, name: "Confiserie" },
    { id: 70183, name: "Graines" },
    { id: 70184, name: "Assorted Sweets" },
    { id: 70185, name: "Boissons" },
    { id: 70186, name: "Olives" },
    { id: 70187, name: "Halawa" },
    { id: 70188, name: "Dip" },
    { id: 72241, name: "Candy Bars" },
    { id: 74452, name: "Vegetables" },
    { id: 74453, name: "Dried fruits" },
    { id: 74454, name: "Spices & Herbs (100g)" },
    { id: 74455, name: "Spices & Herbs (50g)" },
    { id: 74456, name: "Spices & Herbs" },
    { id: 81912, name: "Nuts" },
];